export function getRootElement() {
  const rootElement = document.querySelector<HTMLElement>(
    `[data-tool='solvari-company-registration-form']`,
  );

  if (!rootElement) {
    throw new Error("No root element found");
  }

  return rootElement;
}
